import React, { useState, useEffect, useContext } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { addToCart } from "../../features/cartSlice";
import { IMAGEURL } from "../../config/config";
import favstar from "../../assets/images/favstar.png";
import nonfavimg from "../../assets/images/nonfavimg.png";
import { LoaderContext } from "../utils/Contexts";
import { getproductTitle } from "../utils/LanguageField";
import PriceBox from "../price/renderer/PriceBox";

function Item(props) {
  const { t } = useTranslation();
  const { products, existingItemsInCart } = props;
  const dispatch = useDispatch();
  const { isLoader, setLoader } = useContext(LoaderContext);

  const [quantities, setQuantities] = useState({});
  const [isQtyChanged, setIsQtyChanged] = useState(false);
  const [focusQty, setFocusQty] = useState(0);
  const [currentProductId, setCurrentProductId] = useState("");
  useEffect(() => {
    const initialQuantities = {};
    products.forEach((product) => {
      initialQuantities[product._id] = existingItemsInCart[product._id]
        ? existingItemsInCart[product._id]
        : 0; // Default to 1 if no quantity
    });
    setQuantities(initialQuantities);
  }, [products]);
  let timer;
  const handleEdit = (id, value) => {
    let qty = value.replace(/^0+/, "");
    if (qty <= 0) {
      qty = 0;
    }
    if (!isNaN(qty)) {
      setQuantities((prev) => ({
        ...prev,
        [id]: parseInt(qty),
      }));
    }
  };

  const handleFocus = (id, value) => {
    let qty = value.replace(/^0+/, "");
    setFocusQty(qty);
  };

  const handleBlur = (id, value) => {
    if (focusQty != value) {
      setCurrentProductId(id);
      setIsQtyChanged(true);
    }
  };

  const handleIncrease = (id) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: parseFloat(prev[id]) + 1,
    }));
    setCurrentProductId(id);
    setIsQtyChanged(true);
  };

  const handleDecrease = (id) => {
    let qty = parseFloat(quantities[id]) - 1;
    if (qty < 0) {
      qty = 0;
    }
    if (quantities[id] == qty) {
      return false;
    }
    setQuantities((prev) => ({
      ...prev,
      [id]: prev[id] > 1 ? qty : 0, // Prevent quantity below 1
    }));
    setCurrentProductId(id);
    setIsQtyChanged(true);
  };

  const handleAddToCart = () => {
    if (isQtyChanged) {
      const qty = Number.isInteger(quantities[currentProductId])
        ? quantities[currentProductId]
        : 0;
      if (qty > 0) {
        setLoader(true);
        dispatch(
          addToCart({
            qty,
            product_id: currentProductId,
            customer_id: props.customer_id,
            name: props[getproductTitle("name", "product")],
            translations: {
              added_to_cart: t("added_to_cart"),
              items_added_to_cart: t("items_added_to_cart"),
              removed_from_cart: t("removed_from_cart"),
              qty_updated_cart: t("qty_updated_cart"),
            },
          })
        );
      }
      setIsQtyChanged(false);
    }
  };

  const productLabels =
    props.product_label === "0" ? [] : JSON.parse(props.product_label);

  // Mapping numbers to image paths
  const labelImages = {
    1: require("../../assets/images/Muis-Halal-Logo.png"),
    2: require("../../assets/images/Healthier-Choice-Logo.png"),
    3: require("../../assets/images/Healthier-Choice-Equivalent-Logo.png"),
  };
  return (
    // <div
    //   key={props._id}
    //   className={`Favourites_item_slide ${
    //     props.isFavorite(props._id) ? "favorite" : "nonfavourite"
    //   }`}
    // >
    <div
      key={props._id}
      className={`${props.quantity <= 0 ? "outofstock":"" } Favourites_item_slide ${
        props.isFavorite(props._id) ? "favorite" : "nonfavourite"
      }`}
    >
      <div className="fav_img_labe">
        {productLabels.map((label) => (
          <img key={label} src={labelImages[label]} alt={`labels ${label}`} />
        ))}
        {/* <img src={Halal} alt="labels" />
     <img src={Halal2} alt="labels" />
     <img src={Halal} alt="labels" />
      */}
      </div>
      <a
        href="javascript:void(0)"
        onClick={(e) => props.addToFavorite(e, props)}
      >
        <img
          src={props.isFavorite(props._id) ? favstar : nonfavimg}
          alt="favourite icon"
          className="favstaricn"
        />
      </a>
      <figure>
        <img
          className="proimg"
          src={IMAGEURL + props.image}
          alt="products"
        />
      </figure>
      <div className="protext">
        <p>{props[getproductTitle("name", "product")]}</p>
        <h3>
          <PriceBox item={props} /> Per {props.unit}
        </h3>
      </div>
      <div className="plusminus">
        <div className="plus" onClick={() => handleDecrease(props._id)}></div>
        <div className="inputdata">
          <input
            type="text"
            min={0}
            value={quantities[props._id] || 0}
            maxLength={5}
            onFocus={(e) => handleFocus(props._id, e.target.value)}
            onBlur={(e) => handleBlur(props._id, e.target.value)}
            onChange={(e) => handleEdit(props._id, e.target.value)}
          />
        </div>
        <div className="minus" onClick={() => handleIncrease(props._id)}></div>
        <button className="atc" onClick={() => handleAddToCart()}>{t('add_to_cart')}</button>
      </div>
    </div>
  );
}

export default Item;
